'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight, FeatherCheckCircle, FeatherClock, FeatherFileCheck, FeatherMail, FeatherMessageCircle, FeatherSend, FeatherZap } from '@subframe/core';
import Image from 'next/image';
import type { ComponentType, ReactNode } from 'react';
import { Dialog } from '@/shared/components/ui';
import type { CotaEsgotadaModalProps } from '../types';
const BENEFICIOS = ['Sem interrupção no envio de notificações', 'Mais notificações incluídas todo mês', 'Acesso a recursos extras'];
const TileVidro = t0 => {
  const $ = _c(6);
  const {
    icone: Icone,
    className,
    tamanho: t1
  } = t0;
  const tamanho = t1 === undefined ? "size-8" : t1;
  const t2 = `absolute flex -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-2xl border border-solid border-white/80 bg-gradient-to-br from-white/30 to-black/10 p-4 backdrop-blur-[6px] ${className}`;
  const t3 = `${tamanho} text-white`;
  let t4;
  if ($[0] !== Icone || $[1] !== t3) {
    t4 = <Icone className={t3} />;
    $[0] = Icone;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t2 || $[4] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[3] = t2;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export const CotaEsgotadaModal = t0 => {
  const $ = _c(27);
  const {
    open,
    onClose,
    onVerPlanos,
    emTrial,
    totalBalance
  } = t0;
  if (!open) {
    return null;
  }
  let t1;
  if ($[0] !== totalBalance) {
    t1 = totalBalance != null ? totalBalance.toLocaleString("pt-BR") : "\u2014";
    $[0] = totalBalance;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const franquia = t1;
  const descricao = emTrial ? `Você atingiu o limite de ${franquia} notificações do período de testes. Faça upgrade agora para continuar enviando sem esperar a renovação mensal.` : `Você atingiu o limite de ${franquia} notificações gratuitas. Faça upgrade agora para continuar enviando sem esperar a renovação mensal.`;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src="/icone.svg" alt="Arbitralis" width={32} height={28} className="h-7 w-8" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h1 id="cota-esgotada-titulo" className="text-heading-dark text-2xl font-semibold">Sua cota gratuita acabou por este mês</h1>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== descricao) {
    t4 = <div className="flex flex-col gap-2">{t3}<p id="cota-esgotada-descricao" className="text-base text-neutral-500">{descricao}</p></div>;
    $[4] = descricao;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-4"><span className="text-sm font-medium text-neutral-600">Benefícios:</span>{BENEFICIOS.map(_temp)}</div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <div className="flex flex-col gap-8 px-6 pt-8 pb-5">{t2}{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onClose) {
    t7 = <button type="button" onClick={onClose} className="flex h-11 flex-1 items-center justify-center rounded-lg border border-solid border-neutral-200 bg-white px-4 text-sm font-semibold text-neutral-600 shadow-[0px_1px_2px_0px_rgba(24,29,39,0.08)] transition-colors hover:bg-neutral-50">Agora não</button>;
    $[9] = onClose;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FeatherArrowRight className="size-5" />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== onVerPlanos) {
    t9 = <button type="button" onClick={onVerPlanos} className="bg-brand-700 flex h-11 flex-1 items-center justify-center gap-2 rounded-lg px-4 text-sm font-semibold text-white shadow-[0px_1px_2px_0px_rgba(24,29,39,0.08)] transition-opacity hover:opacity-90">Ver planos{t8}</button>;
    $[12] = onVerPlanos;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== t9) {
    t10 = <div className="flex gap-3 px-8 pt-5 pb-6">{t7}{t9}</div>;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t6) {
    t11 = <div className="flex min-w-0 flex-1 flex-col">{t6}{t10}</div>;
    $[17] = t10;
    $[18] = t6;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Image src="/images/cota/painel-upgrade-fundo.webp" alt="" fill={true} sizes="500px" className="object-cover" />;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="hidden min-w-0 flex-1 self-stretch py-3 pr-3 md:flex"><div className="relative min-h-[520px] w-full overflow-hidden rounded-lg">{t12}<div className="absolute top-1/2 left-1/2 size-[140px] -translate-x-1/2 -translate-y-1/2"><Image src="/images/cota/painel-upgrade-esfera.webp" alt="" fill={true} sizes="140px" className="object-cover" /></div><TileVidro icone={FeatherZap} tamanho="size-10" className="top-[calc(50%-125px)] left-1/2" /><TileVidro icone={FeatherClock} className="top-[calc(50%+127px)] left-1/2" /><TileVidro icone={FeatherMail} className="top-[calc(50%-49px)] left-[calc(50%+122px)]" /><TileVidro icone={FeatherFileCheck} className="top-[calc(50%-49px)] left-[calc(50%-122px)]" /><TileVidro icone={FeatherSend} className="top-[calc(50%+51px)] left-[calc(50%+122px)]" /><TileVidro icone={FeatherMessageCircle} className="top-[calc(50%+51px)] left-[calc(50%-122px)]" /></div></div>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t11) {
    t14 = <Dialog.Content aria-labelledby="cota-esgotada-titulo" aria-describedby="cota-esgotada-descricao" className="w-[calc(100%-2rem)] max-w-[1000px] flex-row items-stretch gap-0 overflow-hidden rounded-[16px] p-0">{t11}{t13}</Dialog.Content>;
    $[22] = t11;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== onClose || $[25] !== t14) {
    t15 = <Dialog open={true} onOpenChange={onClose}>{t14}</Dialog>;
    $[24] = onClose;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  return t15;
};
function _temp(beneficio) {
  return <div key={beneficio} className="flex items-center gap-3 rounded-lg border border-solid border-neutral-200 bg-neutral-50 p-4"><FeatherCheckCircle className="text-success-600 size-6 flex-none" /><span className="text-heading-dark flex-1 text-base">{beneficio}</span></div>;
}